import { ComponentProps, forwardRef } from 'react'

import { FaqSettingMinimal, ImportantLayout } from '@karakuri-web/faq-type'

import { QAContent, QAHeader, QAPanel } from '../components'
import { useFaqRouting } from '../contexts/FaqRoutingContext'
import { values } from '../utils'

/**
 * 重要なお知らせウィジェット用の設定インターフェース
 */
export interface ImportantWidgetSettings extends FaqSettingMinimal {
  importants?: ReadonlyArray<{ id?: string | null; title?: string | null }> | null
}

interface Props<T extends ImportantWidgetSettings = ImportantWidgetSettings> {
  data: { settingYaml: T }
  layout: ImportantLayout
}

/**
 * 重要なお知らせウィジェット
 * 重要なFAQを表示する
 */
export function ImportantWidget<T extends ImportantWidgetSettings = ImportantWidgetSettings>({
  layout,
  data,
}: Props<T>) {
  const { Link } = useFaqRouting()
  const importants = values(data.settingYaml.importants, [])
  if (!importants || importants.length === 0) {
    return null
  }
  return (
    <QAPanel className="faq-panel-important">
      <QAHeader title={`${layout.title || '重要なご質問'}`} />
      {importants.map(({ id, title }) => {
        if (!id || !title) {
          return null
        }
        const LinkComponent = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>(
          function LinkComponent(props, ref) {
            return <Link ref={ref} {...props} to={`/answer/${id}/?important=true`} />
          }
        )
        return <QAContent key={id} question={title} LinkComponent={LinkComponent} />
      })}
    </QAPanel>
  )
}
